import { render } from "./salon-promo-features.vue?vue&type=template&id=6a52bbf2"
import script from "./salon-promo-features.vue?vue&type=script&lang=js"
export * from "./salon-promo-features.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nathan/Dev/justcuts-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__